import React, { useState, useEffect, useRef } from "react";
import { Collapse } from "antd";
import SiteLayout from "components/layout/SiteLayout";
import arrow from "~/assets/camp/arrow@2x.png";
import contact from "~/assets/camp/contact@2x.png";
import dayIcon from "~/assets/camp/day-icon@2x.png";
import dayIconBig from "~/assets/camp/day-icon-big@2x.png";
import dayIconWeb from "~/assets/camp/day-icon-web@2x.png";
import icon1 from "~/assets/camp/icon-1@2x.png";
import icon2 from "~/assets/camp/icon-2@2x.png";
import icon3 from "~/assets/camp/icon-3@2x.png";
import logoSmall from "~/assets/camp/logo-small@2x.png";
import logo from "~/assets/camp/logo@2x.png";
import mbItemIcon from "~/assets/camp/mb-item-icon@2x.png";
import p1 from "~/assets/camp/p1@2x.png";
// import p2 from "~/assets/camp/p2@2x.png";
import p3 from "~/assets/camp/p3@2x.png";
import p4 from "~/assets/camp/p4@2x.png";
import p5 from "~/assets/camp/p5@2x.png";
import p6 from "~/assets/camp/p6@2x.png";
import p7 from "~/assets/camp/p7@2x.png";
import pcItemIcon from "~/assets/camp/pc-item-icon@2x.png";
import safe from "~/assets/camp/safe@2x.png";
import titleIconLeftWhite from "~/assets/camp/title-icon-left-white@2x.png";
import titleIconLeft from "~/assets/camp/title-icon-left@2x.png";
import titleIconRightWhite from "~/assets/camp/title-icon-right-white@2x.png";
import titleIconRight from "~/assets/camp/title-icon-right@2x.png";
import smallArrow from "~/assets/camp/small-arrow@2x.png";
import { Tab } from "components/camp/tab";
const { Panel } = Collapse;

const Page = () => {
  const [accordions, setAccordions] = useState<boolean[]>([]);
  const [isScrolled, setIsScrolled] = useState(false);
  const targetRefs: any = {
    target1: useRef(null),
    target2: useRef(null),
    target3: useRef(null),
    target4: useRef(null),
    target5: useRef(null),
    target6: useRef(null),
    target7: useRef(null),
    target8: useRef(null),
  };

  const toggleState = (i: number) => {
    const newAccordions = [...accordions];
    newAccordions[i] = !newAccordions[i];
    setAccordions(newAccordions);
  };
  const pageScrollBottom = () => {
    window.scroll({
      top: document.body.scrollHeight,
      left: 0,
      behavior: "smooth",
    });
  };

  const boxClass = isScrolled ? "show" : "hide";

  const handleClick = (targetId: any) => {
    targetRefs[targetId].current.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const onScroll = () => {
      if (window.pageYOffset >= 400) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", onScroll);

    // 清除事件监听器
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);
  return (
    <SiteLayout pageTitle="远程工作求职训练营" largeContainer="true">
      <div className="wrapper">
        <Tab active="right" />
        <div className="block1">
          {/* <div className="nav">
            <div className="nav-left">
              <img
                src={textLogo.src}
                alt="logo"
                className="logo"
              />
              <div className="line"></div>
              <span className="text">只工作，不上班</span>
            </div>
            <img className="nav-right-mb" src={more.src} />
            <div className="nav-right-pc">
              <span>适合学员</span>
              <span>课程介绍</span>
              <span>服务保障</span>
              <span>关于训练营</span>
              <span>报名方式</span>
            </div>
          </div> */}
          <div className="header">
            <div className="content">
              <div className="left">
                <div className="text-pc">远程工作求职训练营</div>
                <div className="text-mb">远程工作</div>
                <div className="text-mb">求职训练营</div>
                <div className="text-en">ENGLISH</div>
                <div className="text-en-small">JOB TRAINING CAMP</div>
                <div className="consult" onClick={pageScrollBottom}>
                  立即咨询
                </div>
              </div>
              <img src={logo.src} alt="header" className="header-img" />
            </div>
          </div>
        </div>
        <div className="block2" ref={targetRefs.target1}>
          <div className="title">
            <img src={titleIconLeft.src} />
            <div className="title-text">适合学员</div>
            <img src={titleIconRight.src} />
          </div>
          <div className="item-w">
            <div className="item">
              <img src={icon1.src} />
              <span>对海外工作机会、外企、海外远程</span>
              <span>工作等有兴趣开发者们</span>
            </div>
            <div className="item">
              <img src={icon2.src} />
              <span>缺乏专业的英语求职指导的</span>
              <span>开发者们</span>
            </div>
            <div className="item">
              <img src={icon3.src} />
              <span>其他对程序员英语学习感兴趣，</span>
              <span>想养成长期学习习惯的同学</span>
            </div>
          </div>
        </div>
        <div className="block3" ref={targetRefs.target2}>
          <div className="title">
            <img src={titleIconLeft.src} />
            <div className="title-text">课程介绍</div>
            <img src={titleIconRight.src} />
          </div>
          <Collapse ghost className="content">
            <Panel
              className="panel"
              showArrow={false}
              key={0}
              header={
                <div onClick={() => toggleState(0)}>
                  <div className="course-title">
                    <div className="course-title-left">
                      <div className="line"></div>
                      <div className="course-title-text">面试实战冲刺模块</div>
                      <div className="days">
                        <img className="icon-mp" src={dayIcon.src} />
                        <img className="icon-web" src={dayIconWeb.src} />
                        <div>5天</div>
                      </div>
                    </div>
                    <div>
                      <div className="detail">
                        <span>{`${
                          accordions[0] ? "折叠详情" : "查看详情"
                        }`}</span>
                        <img
                          className={`${accordions[0] ? "arrow-down" : ""}`}
                          src={smallArrow.src}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="course-time">
                    <span>上课时间</span>
                    <span>每周六、日晚上8-10点进行线上课</span>
                  </div>
                  <div className="course-core-text">核心内容</div>
                  <div className="list-wrapper">
                    <div className="list-i">
                      <div className="course-list-title">欢迎加入训练营</div>
                      <ul className="course-list">
                        <li>训练营介绍</li>
                        <li>老师介绍</li>
                        <li className={` ${accordions[0] ? "remove" : ""}`}>
                          ...
                        </li>
                        <div className={`${accordions[0] ? "add" : "remove"}`}>
                          <li>课程安排</li>
                          <li>大家自我介绍</li>
                        </div>
                      </ul>
                    </div>
                    <div className="list-i">
                      <div className="course-list-title">CV insights flow</div>
                      <ul className="course-list">
                        <li>Work in Reality</li>
                        <li>The CV flow from candidates view</li>
                        <li className={`${accordions[0] ? "remove" : ""}`}>
                          ...
                        </li>
                        <div className={`${accordions[0] ? "add" : "remove"}`}>
                          <li>The hidden flow from employer point of view</li>
                          <li>Tech Interview</li>
                          <li>Interview Tips </li>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
              }
            >
              <div className="list-wrapper">
                <div className="list-i">
                  <div className="course-list-title">
                    Build your English Resume
                  </div>
                  <ul className="course-list">
                    <li>Build your Resume step by step</li>
                    <li>
                      Impactful and powerful words included in your resume
                    </li>
                    <li>
                      Your biggest Accomplishments in your life and how to list
                      on your resume
                    </li>
                    <li>Restructure CV with better layout</li>
                  </ul>
                </div>
                <div className="list-i">
                  <div className="course-list-title">
                    Cover Letter&Interview Skills
                  </div>
                  <ul className="course-list">
                    <li>How to write your Cover Letter</li>
                    <li>Interview STAR Method</li>
                    <li>common Behavioral Interview Questions</li>
                    <li>
                      How To Answer Any Question You Have No Idea How to Answer
                    </li>
                    <li>
                      What You Must Know about the Company You will be
                      Interviewed
                    </li>
                    <li>Questions to Ask in The Interviews</li>
                    <li>Package Negotiation</li>
                  </ul>
                </div>
                <div className="list-i">
                  <div className="course-list-title course-list-title-sm">
                    English Interview Strategy + Self-introduction Optimization
                  </div>
                  <ul className="course-list">
                    <li>Overall Interview </li>
                    <li>Underlying Logic and Strategy</li>
                    <li>3 Classic Interview Questions</li>
                    <li>Self-Introduction </li>
                    <li>Present - Past - Future Stucture</li>
                    <li>
                      Strengths and Weakness and Extended Behavioral Questions
                    </li>
                    <li>STAR Method and Examples</li>
                    <li>Individual Self-Introduction 'Sprint'</li>
                  </ul>
                </div>
                <div className="list-i">
                  <div className="course-list-title">
                    兼职平台(如upwork)使用与经验分享
                  </div>
                  <ul className="course-list">
                    <li>Upwork平台的介绍、创建账号流程、收款的方法</li>
                    <li>如何利用平台的规则快速找到第一份Upwork Job</li>
                    <li>从全职工作到Freelancer的思路转变</li>
                    <li>如何合法高效地跨境收款</li>
                    <li>跨境收款的成本分析（含个税</li>
                    <li>Freelancer如何缴社保</li>
                  </ul>
                  <div className="course-list-title">一对一模拟面试</div>
                  <ul className="course-list">
                    <li>面试指导</li>
                    <li>模拟面试复盘</li>
                  </ul>
                </div>
              </div>
            </Panel>
            <Panel
              className="panel"
              showArrow={false}
              key={1}
              header={
                <div onClick={() => toggleState(1)}>
                  <div className="course-title">
                    <div className="course-title-left">
                      <div className="line"></div>
                      <div className="course-title-text">夯实算法模块</div>
                      <div className="days">
                        <img
                          className="icon-mp icon-big"
                          src={dayIconBig.src}
                        />
                        <img className="icon-web" src={dayIconWeb.src} />
                        <div className="big">30天</div>
                      </div>
                    </div>
                    <div>
                      <div className="detail">
                        <span>{`${
                          accordions[1] ? "折叠详情" : "查看详情"
                        }`}</span>
                        <img
                          className={`${accordions[1] ? "arrow-down" : ""}`}
                          src={smallArrow.src}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="course-time">
                    <span>上课时间</span>
                    <span>每周六、日晚上8-10点进行线上课</span>
                  </div>
                  <div className="course-core-text">核心内容</div>
                  <div className="list-wrapper">
                    <div className="list-i">
                      <div className="course-list-title">字符串</div>
                      <ul className="course-list">
                        <li>算法题准备技巧</li>
                        <li>算法题面试技巧</li>

                        <li className={` ${accordions[1] ? "remove" : ""}`}>
                          ...
                        </li>
                        <div className={`${accordions[1] ? "add" : "remove"}`}>
                          <li>
                            【基础知识介绍】介绍字符串在算法中常用的方法，例如：split()、trim()、toCharArray()、charAt(int
                            i)、indexOf(...)、replace(...)、subString(...)、lastIndexOf(...)等等
                          </li>
                          <li>最长回文子串</li>
                          <li>模糊坐标</li>
                          <li>交替合并字符串</li>
                          <li>仅执行一次字符串交换能否使两个字符串相等</li>
                          <li>检查二进制字符串字段</li>
                          <li>在LR字符串中交换相邻字符</li>
                          <li>重新格式化电话号码</li>
                          <li>统计子串中的唯一字符</li>
                          <li>分割字符串的最大得分LeetCode</li>
                          <li>求解方程</li>
                          <li>重新格式化字符串</li>
                          <li>数组中的字符串匹配</li>
                          <li>分数加减运算</li>
                        </div>
                      </ul>
                    </div>
                    <div className="list-i">
                      <div className="course-list-title">链表</div>
                      <ul className="course-list">
                        <li>
                          【基础知识介绍】单向链表、双向链表、链表的常用解题方法……
                        </li>
                        <li>【链表场景】ArrayList、LinkedList</li>
                        <li className={` ${accordions[1] ? "remove" : ""}`}>
                          ...
                        </li>
                        <div className={`${accordions[1] ? "add" : "remove"}`}>
                          <li> 两个链表的第一个公共节点</li>
                          <li>合并两个排序的链表</li>
                          <li>链表中倒数第k个节点</li>
                          <li>从尾到头打印链表</li>
                          <li>反转链表</li>
                        </div>
                      </ul>
                      <div className={`${accordions[1] ? "add" : "remove"}`}>
                        <div className="course-list-title">栈</div>
                        <div className="course-list-title">二分搜索&递归</div>
                        <div className="course-list-title">DFS & BFS</div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            >
              <div className="list-wrapper">
                <div>
                  <div className="list-i">
                    <div className="course-list-title">队列 && 优先队列</div>
                    <ul className="course-list">
                      <li>
                        【基础知识介绍】堆栈和队列的数据结构介绍，以及的常用解题方法……
                      </li>
                      <li>
                        【堆栈场景】了解Stack的用法、利用Deque实现堆栈、Queue
                      </li>
                      <li>包含min函数的栈</li>
                      <li>用两个栈实现队列</li>
                      <li>子数组的最小值之和</li>
                      <li>股票价格跨度</li>
                      <li>最多能完成排序的块</li>
                      <li>最多能完成排序的块 II</li>
                      <li>括号的分数</li>
                      <li>使括号有效的最少添加</li>
                      <li>函数的独占时间</li>
                      <li>行星碰撞</li>
                    </ul>
                  </div>
                  <div className="list-i">
                    <div className="course-list-title">贪心算法</div>
                    <ul className="course-list">
                      <li>
                        【基础知识介绍】讲解贪心算法的解题思路，以及的常用解题方法……
                      </li>
                      <li>通过最少操作次数使数组的和相等</li>
                      <li>优势洗牌</li>
                      <li>三等分</li>
                      <li>雇佣 K 名工人的最低成本</li>
                      <li>盛最多水的容器</li>
                      <li>玩筹码</li>
                      <li>最长数对链</li>
                    </ul>
                  </div>
                  <div className="list-i">
                    <div className="course-list-title">排序</div>
                    <ul className="course-list">
                      <li>
                        【基础知识介绍】讲解排序算法的解题思路，以及的常用解题方法……
                      </li>
                      <li>【LeetCode算法题】</li>
                      <li>扑克牌中的顺子</li>
                      <li>Z 字形变换</li>
                      <li>最大交换</li>
                      <li>特殊数组的特征值</li>
                      <li>优美的排列 II</li>
                      <li>有序队列</li>
                      <li>重建序列</li>
                      <li>特殊的二进制序列</li>
                      <li>最长的斐波那契子序列的长度</li>
                    </ul>
                  </div>
                  <div className="list-i">
                    <div className="course-list-title">双指针&滑动窗口</div>
                    <ul className="course-list">
                      <li>
                        【基础知识介绍】讲解双指针和滑动窗口的解题思路，以及的常用解题方法……
                      </li>
                      <li>水果成篮</li>
                      <li>拆炸弹</li>
                      <li>得到 K 个黑块的最少涂色次数</li>
                      <li>无重复字符的最长子串</li>
                      <li>和为s的两个数字</li>
                      <li>调整数组顺序使奇数位于偶数前面</li>
                      <li>神奇字符串</li>
                      <li>找到 K 个最接近的元素</li>
                    </ul>
                  </div>
                </div>
                <div>
                  <div className="list-i">
                    <div className="course-list-title">矩阵&图</div>
                    <ul className="course-list">
                      <li>
                        【基础知识介绍】矩阵的数据结构介绍，以及的常用解题方法……
                      </li>
                      <li> 最短的桥</li>
                      <li>零矩阵</li>
                      <li>最大人工岛</li>
                      <li>二进制矩阵中的特殊位置</li>
                      <li>二维网格迁移</li>
                      <li>变为棋盘</li>
                      <li>奇数值单元格的数目</li>
                    </ul>
                  </div>
                  <div className="list-i">
                    <div className="course-list-title">二叉树</div>
                    <ul className="course-list">
                      <li>
                        【基础知识介绍】二叉树种类的数据结构介绍（二叉搜索树、平衡二叉树……），介绍关于二叉树的前序、中序、后序、层序，以及的常用解题方法……
                      </li>
                      <li>二叉搜索树的后序遍历序列</li>
                      <li>重建二叉树</li>
                      <li>二叉搜索树的最近公共祖先</li>
                      <li>二叉树的最近公共祖先</li>
                      <li>平衡二叉树</li>
                      <li>二叉树中和为某一值的路径</li>
                      <li>二叉搜索树与双向链表</li>
                      <li>从上到下打印二叉树 III</li>
                      <li>二叉树着色游戏</li>
                      <li>最长同值路径</li>
                      <li>在二叉树中增加一行</li>
                      <li>完全二叉树插入器</li>
                    </ul>
                  </div>
                  <div className="list-i">
                    <div className="course-list-title">回溯</div>
                    <ul className="course-list">
                      <li>
                        【基础知识介绍】讲解回溯的解题思路，以及的常用解题方法……
                      </li>
                      <li>【LeetCode算法题】</li>
                      <li>矩阵中的路径</li>
                      <li>字母大小写全排列</li>
                      <li>相似度为 K 的字符串</li>
                      <li>划分为k个相等的子集</li>
                    </ul>
                  </div>
                  <div className="list-i">
                    <div className="course-list-title">动态规划</div>
                    <ul className="course-list">
                      <li>
                        【基础知识介绍】讲解动态规划的解题思路，以及的常用解题方法……
                      </li>
                      <li>最长不含重复字符的子字符串</li>
                      <li>把数字翻译成字符串</li>
                      <li>礼物的最大价值</li>
                      <li>连续子数组的最大和</li>
                      <li>股票的最大利润</li>
                      <li>青蛙跳台阶问题</li>
                      <li>香槟塔</li>
                      <li>规划兼职工作</li>
                      <li>不同的子序列 II</li>
                      <li>使序列递增的最小交换次数</li>
                      <li>第 k 个数</li>
                    </ul>
                  </div>
                </div>
              </div>
            </Panel>
            <Panel
              className="panel"
              showArrow={false}
              header={
                <div onClick={() => toggleState(2)}>
                  <div className="course-title">
                    <div className="course-title-left">
                      <div className="line"></div>
                      <div className="course-title-text">英语陪学提升模块</div>
                      <div className="days">
                        <img
                          className="icon-mp icon-big"
                          src={dayIconBig.src}
                        />
                        <img className="icon-web" src={dayIconWeb.src} />
                        <div className="big">90天</div>
                      </div>
                    </div>
                    <div>
                      <div className="detail">
                        <span>{`${
                          accordions[2] ? "折叠详情" : "查看详情"
                        }`}</span>
                        <img
                          className={`${accordions[2] ? "arrow-down" : ""}`}
                          src={smallArrow.src}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="course-time">
                    <span>上课时间</span>
                    <span>每周教练会跟你预约一对一陪学时间课</span>
                  </div>
                  <div className="course-core-text">核心内容</div>
                  <div className="list-wrapper">
                    <div className="list-i">
                      <div className="course-list-title">一对一陪伴式学习</div>
                      <ul className="course-list">
                        <li>英语能力评测与个性化学习指导建议、方案</li>
                        <li>每周进行一对一纠音</li>
                        <li className={`${accordions[2] ? "remove" : ""}`}>
                          ...
                        </li>
                        <div className={`${accordions[2] ? "add" : "remove"}`}>
                          <li>每周检查学习进度与答疑</li>
                        </div>
                      </ul>
                    </div>
                    <div className="list-i">
                      <div className="course-list-title">纯英语高质量群聊</div>
                      <ul className="course-list">
                        <li>专业老师负责群运营，保证群活跃</li>
                        <li>每周一个主题，避免没有话题</li>
                        <li className={` ${accordions[2] ? "remove" : ""}`}>
                          ...
                        </li>
                        <div className={`${accordions[2] ? "add" : "remove"}`}>
                          <li>老师实时负责纠错</li>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
              }
              key="2"
            >
              <div className="list-wrapper">
                <div className="list-i">
                  <div className="course-list-title">电鸭专属</div>
                  <ul className="course-list">
                    <li>程序员常用200词</li>
                    <li>针对程序员专用场景英语400句</li>
                  </ul>
                </div>
                <div className="list-i">
                  <div className="course-list-title">
                    英语学习经验分享，视频课
                  </div>
                  <div className="course-list-title">每日一句</div>
                  <div className="course-list-title">读写练习贴</div>
                </div>
              </div>
            </Panel>
          </Collapse>
        </div>
        <div className="block4" ref={targetRefs.target3}>
          <div className="title">
            <img src={titleIconLeftWhite.src} />
            <div className="title-text">服务保障</div>
            <img src={titleIconRightWhite.src} />
          </div>
          <div className="content">
            <div className="content-left">
              <div>
                <img src={mbItemIcon.src} />
                <img src={pcItemIcon.src} />
                <p>
                  我们的学员享受人才库专属职位推荐服务，直到找到合适的工作机会
                </p>
              </div>
              <div>
                <img src={mbItemIcon.src} />
                <img src={pcItemIcon.src} />
                <p>国内外大厂无限次内推服务</p>
              </div>
              <div>
                <img src={mbItemIcon.src} />
                <img src={pcItemIcon.src} />
                <p>90天班主任全程精细化督导，90天老师陪伴式学习、无限次答疑</p>
              </div>
              <div>
                <img src={mbItemIcon.src} />
                <img src={pcItemIcon.src} />
                <p>全英语沟通社群，更有老师一对一陪学</p>
              </div>
              <div>
                <img src={mbItemIcon.src} />
                <img src={pcItemIcon.src} />
                <p>全球优质远程、全职、兼职工作机会，学习期间分享60+个职位</p>
              </div>
              <div>
                <img src={mbItemIcon.src} />
                <img src={pcItemIcon.src} />
                <p>不定期邀请拿到offer或兼职的同学分享经验</p>
              </div>
              <div>
                <img src={mbItemIcon.src} />
                <img src={pcItemIcon.src} />
                <p>结识一群和你有相同目标，一起奋斗的小伙伴</p>
              </div>
              <div>
                <img src={mbItemIcon.src} />
                <img src={pcItemIcon.src} />
                <p>
                  训练营学员享人才库免费推荐入职1次（价值5K+；仅限全额入营）
                </p>
              </div>
              <div>
                <img src={mbItemIcon.src} />
                <img src={pcItemIcon.src} />
                <p>教练帮忙一对一修改简历</p>
              </div>
            </div>
            <img className="content-right" src={safe.src} />
          </div>
        </div>
        <div className="block5" ref={targetRefs.target4}>
          <div className="title">
            <img src={titleIconLeft.src} />
            <div className="title-text">老师简介</div>
            <img src={titleIconRight.src} />
          </div>
          <div className="content">
            <div className="item">
              <img className="arrow" src={arrow.src} />
              <span>CJ</span>
              <span>老师</span>
              <p>
                瑞典读CS硕(全英文授课)，在沃尔沃实习后，先后进入当地不同公司做软件开发，参与的行业涉及通信，汽车，SaaS,IoT等，公司多是像爱立信，奔驰之类的跨国企业。期间主要负责过后端开发，全栈开发，运维，嵌入式，云计算等，-线开发经验超过10年。作为面试官协助公司做过技术面试，了解纯英文环境下的开发交流和面试流程。目前在瑞典经营有自己的IT公司。
              </p>
            </div>
            <div className="item">
              <img className="arrow" src={arrow.src} />
              <span>Jessie</span>
              <span>老师</span>
              <p>
                天津大学EE硕士，原中兴通讯软件开发工程师，2010年移民加拿大，现在某通信公司做软件开发。2017年创建并组织
                Ottawa Leibniz IT
                Club，召集Ottawa的IT精英做技术分享的同时，组织求职面试培训+多期，修改IT技术简历上百份。
              </p>
            </div>
            <div className="item">
              <img className="arrow" src={arrow.src} />
              <span>Jason</span>
              <span>老师</span>
              <p>
                原ZTE软件工程师，从事RFID系统开发，搭建CI/CD流程和自动化测试，同时，负责新员工的技术培训。2010后来到加拿大，先后就职于cisco和nokia，从事网络功能虚拟化和云计算的软件设计和开发工作。
              </p>
            </div>
            <div className="item">
              <img className="arrow" src={arrow.src} />
              <span>Tina</span>
              <span>老师</span>
              <p>
                香港城市大学信息管理专业博士. 2014年起, 先后在荷兰,
                英国和美国等金融外企香港分区任职, 做数据分析和项目管理工作.
                读博和工作期间都为全英文工作环境, 外部客户多为跨国公司. 优势:
                英语口语能力相对突出.
                欧美外企和文化沟通技巧和金融数据分析职场经验。
              </p>
            </div>
            <img className="p1" src={p1.src} />
          </div>
        </div>
        <div className="block6" ref={targetRefs.target5}>
          <div className="title">
            <img src={titleIconLeft.src} />
            <div className="title-text">你能得到什么?</div>
            <img src={titleIconRight.src} />
          </div>
          <div className="content">
            <div className="block">
              <div className="item">
                <div>
                  <span>01. </span>简历
                </div>
                <div>
                  <p>
                    <span>a.</span>
                    <span>一份精心打磨的英文简历</span>
                  </p>
                  <p>
                    <span>b.</span>
                    <span>面向JD写求职信的正确姿势</span>
                  </p>
                  <p>
                    <span>c.</span>
                    <span>个性化简历和求职信的修改和辅导</span>
                  </p>
                </div>
              </div>
              <div className="item">
                <div>
                  <span>02. </span>面试环节
                </div>
                <div>
                  <p>
                    <span>a.</span>
                    <span>对面试官想要考察的点与想要的答案了如指掌;</span>
                  </p>
                  <p>
                    <span>b.</span>
                    <span>面试环节的注意事项和Tips心中有数;</span>
                  </p>
                  <p>
                    <span>c.</span>
                    <span>面对算法题游刃有余。</span>
                  </p>
                  <p>
                    <span>d.</span>
                    <span>系统设计面试对答如流</span>
                  </p>
                </div>
              </div>
              <div className="item item-pc">
                <div>
                  <span>03. </span>英语
                </div>
                <div>
                  <p>
                    <span>a.</span>
                    <span>一对一陪伴式学习，无限次专属老师答疑纠音</span>
                  </p>
                  <p>
                    <span>b.</span>
                    <span>能轻松读懂与编写技术相关内容</span>
                  </p>
                  <p>
                    <span>c.</span>
                    <span>日常工作口语能正常沟通</span>
                  </p>
                  <p>
                    <span>d.</span>通过为期3月的学习养成良好的英语学习习惯
                  </p>
                </div>
              </div>
            </div>
            <div className="en">
              <div>
                <span className="en-text">03.</span>英语
              </div>
              <div>
                <p>
                  <span>a.</span>
                  <span>一对一陪伴式学习，无限次专属老师答疑纠音</span>
                </p>
                <p>
                  <span>b.</span>
                  <span>能轻松读懂与编写技术相关内容</span>
                </p>
                <p>
                  <span>c.</span>
                  <span>日常工作口语能正常沟通</span>{" "}
                </p>
                <p>
                  <span>d.</span>通过为期3月的学习养成良好的英语学习习惯
                </p>
              </div>
            </div>
            <div className="list">
              <div>
                <span>04.</span>国内外大厂无限次内推服务
              </div>
              <div>
                <span>05.</span>upwork等兼职平台轻车熟路
              </div>
              <div>
                <span>06.</span>海外团队前沿技术栈介绍
              </div>
              <div>
                <span>07.</span>了解国外主流开发协作及团队沟通工具
              </div>
              <div>
                <span>08.</span>一系列开发者常用表达学习集及记忆工具
              </div>
              <div>
                <span>09.</span>一个高质量的英语听说读写群聊及纠错服务
              </div>
            </div>
            <img className="p6" src={p6.src} />
            <img className="p7" src={p7.src} />
          </div>
          <img className="p3" src={p3.src} />
        </div>
        <div className="block7" ref={targetRefs.target6}>
          <div className="title">
            <img src={titleIconLeft.src} />
            <div className="title-text">关于训练营</div>
            <img src={titleIconRight.src} />
          </div>
          <div className="content">
            <p className="about">
              感谢大家一直以来对训练营的支持与信任。在过往两年训练营的举办中我们不忘初心，对每个环节每节课都精磨细练。为了训练营能更好的服务大家，在多次竞品调研、实践摸索和内部筹划后，我们准备对训练营进行一次全面的更新。针对基础好且短期想找到工作的同学，我们升级了面试实战冲刺模块，针对基础相对薄弱的同学，我们新增了重点新增了算法模块与英语陪学模块；具体内容在下方模块简介，希望本次更新能让所有同学都找到心仪的工作。
            </p>
            <div className="tag tag-big">训练营的训练方法论</div>
            <div className="item-w">
              <div className="item">
                <div className="item-title">
                  <div className="line"></div>
                  <div className="item-title-text">
                    不面向工作机会的英语培训都是坐而论道，训练是为了能使用英语工作入职；
                  </div>
                </div>
                <div className="item-content">
                  <ul>
                    <li>开发者求职场景下的英语使用</li>
                    <li>英语在开发者日常工作中的使用</li>
                    <li>英文简历/求职信</li>
                    <li>英语面试Tips/系统设计模拟</li>
                    <li>团队协作模拟/日常群聊模拟</li>
                  </ul>
                  <img className="p4" src={p4.src} />
                </div>
              </div>
              <div className="item">
                <div className="item-title">
                  <div className="line"></div>
                  <div className="item-title-text">
                    不融入使用场景的英语培训都是纸上谈兵；你训练的场景就是你实际工作场景；
                  </div>
                </div>
                <div className="item-content">
                  <ul>
                    <li>使用Gmail / Trello等进行文档协做和任务安排</li>
                    <li>使用Zoom进行在线会议</li>
                  </ul>
                  <img className="p5" src={p5.src} />
                </div>
              </div>
            </div>
            <div className="tag">Q&A</div>
            <div className="qa-item-w">
              <div className="item">
                <div>Q：可以单独购买一个模块吗？</div>
                <p>
                  可以，面试实战冲刺模块4980，夯实算法模块4980，英语陪学提升模块6980；任选其二打八折
                </p>
              </div>
              <div className="item">
                <div>
                  Q：为什么选用的是Github/ Google Docs/Zoom，而不是其他工具?
                </div>
                <p>
                  这里只是罗列了一部分工具，课程上选用的工具都是为了能让大家提前适应外企或远程工作
                </p>
              </div>
              <div className="item">
                <div>Q：可以便宜点么?</div>
                <p>
                  90天陪伴式学习指导与服务，对比市面上任何培训课程的内容和价格都是性价比非常高的，真便宜不了，请理解。且随着训练内容不断优化、服务质量持续提升、以及新老师的加入，训练营的价格是会同步上提的，越到后面，价格越高，早报反而更便宜些。
                </p>
              </div>
              <div className="item">
                <div>Q：那什么。。可以退费么?</div>
                <p>可以。开营48小时内，如你觉得不适合自己，无条件退全款。</p>
              </div>
            </div>
          </div>
        </div>
        <div className="block8" ref={targetRefs.target7}>
          <div className="title">
            <img src={titleIconLeftWhite.src} />
            <div className="title-text">价格及日期</div>
            <img src={titleIconRightWhite.src} />
          </div>
          <div className="content">
            <div className="text1">每期仅限20名以内，保证学习质量！</div>
            <div className="tag">日期安排</div>
            <div className="item-w">
              <div>第十一期：￥9960； 2023年4月8号前开营</div>
              <div>第十二期：￥10980； 2023年6月3号前开营</div>
              <div>第十三期：￥10980；2023年8月19号前开营</div>
              <div>
                第十四期:￥10980；2023年10月28号前开营；提前咨询有惊喜！
              </div>
              <div>第十五期：￥10980；预计2024年1月13号前开营</div>
              <div>第十六期：￥10980；预计2024年5月18日前开营</div>
              <div>第十七期：￥10980；预计2024年10月13日开营</div>
            </div>
          </div>
        </div>
        <div className="block9" ref={targetRefs.target8}>
          <div className="title">
            <img src={titleIconLeft.src} />
            <div className="title-text title-text-mp">最后，如何报名</div>
            <div className="title-text title-text-pc">
              最后，有疑问或报名参加
            </div>
            <img src={titleIconRight.src} />
          </div>
          <div className="text1">请联系训练营负责人</div>
          <img className="contact" src={contact.src} />
        </div>
      </div>
      <div className={`${boxClass} menu-w`}>
        <img src={logoSmall.src} />
        <div className="menu">
          <a onClick={() => handleClick("target1")}>适合学员</a>
          <a onClick={() => handleClick("target2")}>课程介绍</a>
          <a onClick={() => handleClick("target3")}>服务保障</a>
          <a onClick={() => handleClick("target4")}>老师简介</a>
          <a onClick={() => handleClick("target5")}>你能得到什么</a>
          <a onClick={() => handleClick("target6")}>关于训练营</a>
          <a onClick={() => handleClick("target7")}>价格及日期</a>
          <a onClick={() => handleClick("target8")}>如何报名</a>
        </div>
      </div>
    </SiteLayout>
  );
};
export default Page;
